import { readLocalStorage, writeLocalStorage } from '../../../modules/storage';

const MAX_LAST_OPENED_VIEWS = 10;

export default function setLastOpenedViewId(appId: string, pageId: number | undefined): void {
  let lastOpenedViews = readLocalStorage(`last-opened-view-${appId}`);
  if (lastOpenedViews && Array.isArray(lastOpenedViews)) {
    lastOpenedViews = Array.from(new Set([pageId, ...lastOpenedViews])).slice(0, MAX_LAST_OPENED_VIEWS);
  } else {
    lastOpenedViews = [pageId];
  }
  return writeLocalStorage(`last-opened-view-${appId}`, lastOpenedViews);
}
